import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Partner } from '../../models/partner';
import { MatDialog } from '@angular/material/dialog';
import { WaiverDialogComponent } from '../waiver-dialog/waiver-dialog.component';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalizationService } from '../../../../services/localization.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-waiver-checkbox',
  templateUrl: './waiver-checkbox.component.html',
  styleUrls: ['./waiver-checkbox.component.css']
})
export class WaiverCheckboxComponent implements OnInit {

  @Input()
  partner: Partner;

  @Input()
  hasError: boolean;

  @Output()
  waiverAgbAgreeChanged = new EventEmitter<any>();

  private _waiverHtml: string;

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
  }

  checkedChanged(event: any): void {
    this.waiverAgbAgreeChanged.emit(event);
  }

  onCheckboxClick($event): void {
    if (this.partner.waiver) {
      return;
    }

    $event.preventDefault();
    this.openDialog();
  }

  openDialog(): void {
    this.waiver.subscribe(
      (waiverHtml: string) => {
        this.dialog.open(WaiverDialogComponent, {
          height: '90%',
          data: {
            partner: this.partner,
            waiver: waiverHtml
          }
        });
      });
  }

  get waiver(): Observable<string> {
    if (this._waiverHtml) {
      return of(this._waiverHtml);
    }
    const waiver_path = 'assets/html/waiver.html';
    return this.http.get(waiver_path)
      .pipe(map(
        (result: string) => {
          this._waiverHtml = result;
          return result;
        }));
  }

}
